import React from "react";
import { useTranslation } from "react-i18next";
import { SubscriptionLicenseType } from "../../../../services/Api/Subscription/subscriptionTypes";

interface Props {
	license_type: SubscriptionLicenseType;
}

const FormatSubscriptionLicenseType = ({ license_type }: Props) => {
	let labelClass = "";
	const { t } = useTranslation();
	switch (license_type) {
		case SubscriptionLicenseType.TRIAL:
			labelClass = "bg-warning text-dark";
			break;
		case SubscriptionLicenseType.STANDARD:
			labelClass = "bg-success";
			break;
		case SubscriptionLicenseType.CANCELLED:
		case SubscriptionLicenseType.NONE:
			labelClass = "bg-danger";
			break;
		case SubscriptionLicenseType.PAUSED:
			labelClass = "bg-dark-border";
			break;
		case SubscriptionLicenseType.FUTURE:
		case SubscriptionLicenseType.MANUAL:
			labelClass = "bg-primary";
			break;
		default:
			labelClass = "bg-primary";
			break;
	}

	return <span className={`badge ${labelClass}`}>{t(`enums.licenses.${license_type}`)}</span>;
};

export default FormatSubscriptionLicenseType;

// t("enums.licenses.STANDARD");
// t("enums.licenses.FUTURE");
// t("enums.licenses.CANCELLED");
// t("enums.licenses.TRIAL");
// t("enums.licenses.PAUSED");
// t("enums.licenses.NONE");
// t("enums.licenses.PAUSED");
// t("enums.licenses.MANUAL");
